module.exports = __webpack_public_path__ + "img/powericon.4694b746.png";